import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { useRegion } from '../context/RegionContext';

const pop = keyframes`
  0%   { transform: scale(0.4); opacity: 0; }
  70%  { transform: scale(1.1); }
  100% { transform: scale(1);   opacity: 1; }
`;

const Shell = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0D0B08;
  padding: 40px 24px;
`;

const Card = styled.div`
  max-width: 440px;
  width: 100%;
  background: #1A1208;
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 20px;
  padding: 48px 40px;
  text-align: center;
  color: #FFFDF7;
`;

const IconWrap = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 72px; height: 72px;
  border-radius: 50%;
  background: rgba(224,82,82,0.1);
  margin-bottom: 24px;
  animation: ${pop} 0.5s cubic-bezier(0.16,1,0.3,1) both;
  svg { color: #E05252; }
`;

const Title = styled.h1`
  font-family: 'Cormorant Garamond', serif;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 10px;
`;

const Sub = styled.p`
  font-size: 0.9rem;
  color: rgba(255,253,247,0.6);
  line-height: 1.65;
  margin-bottom: 32px;
`;

const Btns = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const PrimaryBtn = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 13px 36px;
  border-radius: 999px;
  background: #7C3A00;
  color: #FFFDF7;
  font-size: 0.85rem;
  font-weight: 500;
  letter-spacing: 0.06em;
  transition: background 0.2s;
  &:hover { background: #C07020; }
`;

const GhostBtn = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 13px 36px;
  border-radius: 999px;
  background: transparent;
  border: 1px solid rgba(255,255,255,0.15);
  color: rgba(255,253,247,0.7);
  font-size: 0.85rem;
  font-weight: 500;
  letter-spacing: 0.06em;
  transition: background 0.2s, color 0.2s;
  &:hover { background: rgba(255,255,255,0.06); color: #FFFDF7; }
`;

export default function CancelPage() {
  const { region } = useRegion();
  return (
    <Shell>
      <Card>
        <IconWrap><XCircle size={36} strokeWidth={1.5} /></IconWrap>
        <Title>Pago cancelado</Title>
        <Sub>
          No se realizó ningún cargo. Puedes intentarlo de nuevo cuando quieras.
        </Sub>
        <Btns>
          <PrimaryBtn to={`/${region}/store`}>Volver a la tienda</PrimaryBtn>
          <GhostBtn to={`/${region}`}>Ir al inicio</GhostBtn>
        </Btns>
      </Card>
    </Shell>
  );
}
